<template>
	<div>
		<h1>Search Strategy</h1>

		<InputSelectMultiWithoutOthers
			question="Who designed and ran the search strategy?"
			v-model="$tera.project.searchStrategyAuthors"
			:options="this.dsSearchStrategyAuthors"
			questionMark="searchstrategy-0"
		/>
		<InputSelectMultiWithoutOthers
			question="Who deduplicated the results?"
			v-model="$tera.project.searchStrategyAuthors"
			:options="this.dsSearchStrategyAuthors"
			questionMark="searchstrategy-1"
		/>

		<InputSelectMulti
			question="Which of the following components went into your search string"
			v-model="$tera.project.components"
			:options="componentsOptions"
			questionMark="searchstrategy-2"
		/>

		<InputSelectMulti
			question="Was the search designed by a search specialist, if so select which type"
			v-model="$tera.project.specialist"
			:options="specialistOptions"
			questionMark="searchstrategy-3"
		/>

		<InputSelectMulti
			question="Was help received during the designing of the search, if so who provided the help"
			v-model="$tera.project.helper"
			:options="specialistOptions"
			questionMark="searchstrategy-4"
		/>

		<InputSelectMulti
			question="Which tool/s, if any, were used to help with the search."
			v-model="$tera.project.tools"
			:options="toollistOptions"
			questionMark="searchstrategy-5"
		/>

		<InputSelectMulti
			question="Was the search strategy peer-reviewed (according to PRESS guidelines), if so who peer-reviewed"
			v-model="$tera.project.peerReviewer"
			:options="specialistOptions"
			questionMark="searchstrategy-6"
		/>

		<InputSelectYesNo
			question="Were the search results restricted by publication type?"
			v-model="$tera.project.isRestrictedByPublicationType"
		/>

		<InputSelectMulti
			v-if="$tera.project.isRestrictedByPublicationType"
			question="What publication types did you exclude?"
			v-model="$tera.project.excludedPublicationTypes"
			:options="publicationTypesOptions"
			questionMark="searchstrategy-7"
		/>

		<InputSelectYesNo
			question="Were the search results restricted by language?"
			v-model="$tera.project.isRestrictedByLanguage"
		/>

		<InputSelectMulti
			v-if="$tera.project.isRestrictedByLanguage"
			question="What languages did you include?"
			:options="languageOptions"
			v-model="$tera.project.includedLanguages"
			questionMark="searchstrategy-8"
		/>

		<InputSelectMultiWithoutOthers
			question="Who conducted the supplementary searches?"
			v-model="$tera.project.conductSSearchAuthors"
			:options="this.csAuthors"
			questionMark="searchstrategy-9"
		/>

		<InputSelectMulti
			question="Did you conduct any of the following methods to supplement your search results?"
			v-model="$tera.project.supplementoryMethods"
			:options="supplementoryMethodsOptions"
			questionMark="searchstrategy-10"
		/>

		<InputSelectMulti
			question="Which tool/s or databases were used the supplementary search."
			v-model="$tera.project.databaseTools"
			:options="databaselistOptions"
			questionMark="searchstrategy-11"
		/>

		<PreviewOutput :component="outputComponent" />
	</div>
</template>

<script>
//Search Strategy
import PreviewOutput from "@/components/BasePreviewOutput.vue";
import InputSelectMulti from "@/components/InputSelectMulti.vue";
import InputSelectMultiWithoutOthers from "@/components/InputSelectMultiWithoutOther.vue";
import InputSelectYesNo from "@/components/InputSelectYesNo.vue";
import OutputSearchStrategy from "./OutputSearchStrategy.vue";

export default {
	name: "ViewMethodSearchStrategy",

	components: {
		//Search Strategy
		InputSelectMulti,
		InputSelectMultiWithoutOthers,
		PreviewOutput,
		//Restrictions on Publication Type
		InputSelectYesNo
		//Supplementary Searches
	},
	computed: {
		dsSearchStrategyAuthors() {
			let da = this.$tera.project.author?.map(el => {
				return { label: el };
			});
			this.$tera.project.planTable?.rows.forEach(el => {
				if (
					el.tasks == "Design systematic search strategy" &&
					el.peopleInvolved != ""
				) {
					//da = el.peopleInvolved;
					da = [...el.peopleInvolved, ...da];
					this.checkUnion(da);
				}
			});
			return da;
		},
		csAuthors() {
			let da = this.$tera.project.author?.map(el => {
				return { label: el };
			});
			this.$tera.project.planTable?.rows.forEach(el => {
				if (el.tasks == "Citation search" && el.peopleInvolved != "") {
					//da = el.peopleInvolved;
					da = [...el.peopleInvolved, ...da];
					this.checkUnion(da);
				}
			});
			return da;
		}
	},
	methods: {
		checkUnion(U) {
			for (var i = 0; i < U.length; i++) {
				for (var j = i + 1; j < U.length; j++) {
					if (U[i].label == U[j].label) {
						U.splice(j, 1);
						j--;
					}
				}
			}
		}
	},
	data() {
		return {
			//Search Strategy
			componentsOptions: [
				{ label: "MeSH or other subject terms" },
				{ label: "Synonyms" },
				{ label: "Search filters" }
			],
			specialistOptions: [
				{ label: "Librarian" },
				{ label: "Health Librarian" },
				{ label: "Information Specialist" },
				{ label: "Cochrane Information Specialist" }
			],
			// Tools help in Search
			toollistOptions: [
				{ label: "MeshMate" },
				{ label: "Word Freq" },
				{ label: "SearchRefiner" },
				{ label: "Polyglot Search Translator" },
				{ label: "The Evidence Review Accelerator" }
			],
			// Database helped in Suplementary Search
			databaselistOptions: [
				{ label: "SpiderCite" },
				{ label: "CitationChaser" },
				{ label: "Web of Science" },
				{ label: "Scopus" },
				{ label: "Google Scholar" }
			],
			//Restrictions on Publication Type
			publicationTypesOptions: [
				{ label: "Conference abstracts" },
				{ label: "Theses" },
				{ label: "Articles in press" },
				{ label: "Books or book chapters" }
			],
			languageOptions: [
				{ label: "English" },
				{ label: "German" },
				{ label: "French" },
				{ label: "Italian" },
				{ label: "Spanish" },
				{ label: "Portuguese" },
				{ label: "Chinese" },
				{ label: "Japanese" },
				{ label: "Arabic" },
				{ label: "Swahili" },
				{ label: "Hindi" },
				{ label: "Dutch" },
				{ label: "Swiss" },
				{ label: "Norwegian" },
				{ label: "Swedish" }
			],
			//Supplementary Searches
			supplementoryMethodsOptions: [
				// eslint-disable-next-line prettier/prettier
				{
					label: "Manually checked the reference lists of the included studies"
				},
				{ label: "Performed a backwards citation analysis" },
				{ label: "Performed a forwards citation analysis" },
				{ label: "Contacted experts" },
				{ label: "Used the similar articles feature of a database" }
			],

			outputComponent: OutputSearchStrategy
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
